import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';
const DownloadFromCloud: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || 24}
      height={size || 24}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M15 15.75h3.5c2.6 0 4.7-1 4.7-3.55s-2.5-3.45-4.5-3.55c-0.42-2.55-3.4-4.8-6.7-4.8-3.25 0-5.35 2.15-6 4.3-2.8 0.25-5.3 1.7-5.3 4.65s2.5 4.65 5.3 4.65h2.7m0 3 3 3 3-3M12 10.5v10.5"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default DownloadFromCloud;
